// extracted by mini-css-extract-plugin
var _1 = "ProfileResponsibleManagersWidgetItemIcons-moduleProfileResponsibleManagersWidgetItemIcons__TGuWb";
export { _1 as "ProfileResponsibleManagersWidgetItemIcons" }
